// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1lt4j","centered":"styles_centered__7xx_3","textWrapper":"styles_textWrapper__tkcE4"};